import { createReducer } from 'redux-act'
import u from 'updeep'

import {
  receive as receiveEvent,
  setCurrentEvent,
} from 'actions/events'

// const initialState = {
//   '5913b488091935e449b05b72': {
//     en: {
//       cellar: {},
//       duration: {},
//       price: {},
//       payment: {
//         enabled: true,
//         amounts: [1],
//         refunds: [0.5],
//         refundable: true,
//         hours: 48,
//       },
//       location: {
//         address: {
//           street: {},
//           number: {},
//           zip: {},
//           city: {},
//           province: {},
//           coords: {},
//         },
//       },
//     },
//   },
// };

const initialState = {}

export default createReducer({
  [receiveEvent]: (state, { id, locale, event }) => {
    return event ?
      u({ [id]: { [locale]: event }, eventLocale: locale }, state)
      :
      u({}, state)
  },
  [setCurrentEvent]: (state, { id }) => {
    return u({ eventId: id }, state)
  },
}, initialState)
